import { createContext } from "react";

export const WeekIndexContext = createContext({
	weekIndex: 0,
	setWeekIndex: (_: number): void => {},
	viewStartDay: 0,
	setViewStartDay: (_: number): void => {},
});
